var Forms = function() {
  var self = this;

  this.inputs = $('input, select, button[type=submit], textarea');
  this.forms = $('form');
  this.locationForms = $(
    '#eclub-form, #contact-form, #madness-form, #nscwd-form, #pageant-form, #location-update-form'
  );

  this.init = function() {
    self.loadScripts();
    self.registerEvents();
    self.updateFormLabel();
    self.fileFields();
    self.validation();

    if (self.locationForms.length) {
      self.locationFormSetup();
    }
  };


  this.loadScripts = function() {
    $.getScript( "https://cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.19.3/jquery.validate.min.js", function( data, textStatus, jqxhr ) {
      console.log( "Load was performed." );
      $.getScript( "https://cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.19.3/additional-methods.min.js", function( data, textStatus, jqxhr ) {
        console.log( "Load was performed." );
      });
    });
  }
  this.registerEvents = function() {
    this.inputs.on('blur input change keyup click', updateFormLabel);
    this.forms.on('submit', processForm);
    this.inputs.on('focus', fieldActive);
    this.inputs.on('blur focusout', fieldInactive);
    if ($('[name=category]').length) {
      if ($('.unittype').length) {
        $('.unittype').hide();
        $('[name=category]').on('change', function() {
          if (
            $(this)
              .parents()
              .hasClass('shopping')
          ) {
            $('.unittype').show();
          } else {
            $('.unittype').hide();
          }
        });
      }
    }
  };

  this.fileFields = function() {
    $('input[type="file"]').each(function() {
      var input = $(this);
      var filename = $(this)
        .parent()
        .next('.form-field__filename');
      input.on('change blur', function(e) {
        var files = input.get(0).files;
        filename.text(files[0] ? files[0].name : 'Upload File');
      });
    });
  };

  this.locationFormSetup = function() {
    $('#location-state', self.locationForms).change(locationSwitch);

    $.getJSON('/api/location_states', function(data) {
      var options = ['<option value="" disabled selected></option>'];

      for (var i in data) {
        options.push(
          '<option value="' + data[i].abbrev + '">' + data[i].name + '</option>'
        );
      }

      $('#location-state').html(options.join('\n'));
    });

    if ($('#location_enable').length) {
      $('#contact-location').hide();

      $('#location_enable').change(function() {
        if ($(this).is(':checked')) {
          $('#contact-location').show();
        } else {
          $('#contact-location').hide();
        }
      });
    }
  };

  this.locationSwitch = function(e) {
    var query = '?state=' + $('#location-state').val();
    if ($('#contact-form').length) {
      query += ' &marketforce=1';
    }

    $.getJSON('/api/locations_by_state' + query, function(data) {
      var options = ['<option value="" disabled selected></option>'];

      for (var i in data) {
        var value,
          label = data[i]['name'];
        if ($('#contact-form').length) {
          value = data[i]['cost_center'];
        } else {
          value = data[i]['name'];
        }
        options.push(
          '<option value="' + value + '">Hooters of ' + label + '</option>'
        );
      }

      $('#location-store').html(options.join('\n'));
    });
  };

  this.fieldActive = function() {
    $(this)
      .parents('.form-group')
      .addClass('form-group--active');
  };

  this.fieldInactive = function() {
    $(this)
      .parents('.form-group')
      .removeClass('form-group--active');
  };

  this.updateFormLabel = function(e) {
    var input = e ? e.target : self.inputs;
    $(inputs).each(function() {
      var text = $(this)
        .siblings('label, span')
        .first()
        .text();
      console.log('text', text.trim().slice(0,1))
      if ($(this).attr('required')) {
        if (text.trim().slice(-1) !== '*' && text.trim().slice(0,1) !== '*') {
          $(this)
            .siblings('label, span')
            .first()
            .text(text + '*');
        }
      } else {
        if (text.slice(-1) == '*') {
          $(this)
            .siblings('label, span')
            .first()
            .text(text.slice(0, -1));
        }
      }
      if (
        $(this).attr('type') == 'checkbox' ||
        $(this).attr('type') == 'radio'
      ) {
        return;
      }
      if ($(this).val() && $(this).val().length !== 0) {
        $(this).addClass('filled');
      } else {
        $(this).removeClass('filled');
      }
    });
  };

  this.processForm = function(e) {
    var form = $(e.target);
    var data = new FormData($(form).get(0));
    var endpoint = $(form).attr('action');
    var ajaxSubmit =
      typeof $(form).data('ajax') != 'undefined' ? $(form).data('ajax') : true;

    if (self.formValid(form)) {
      if (ajaxSubmit) {
        self.submit(form, endpoint, data);
        return false;
      }
    } else {
      return false;
    }
  };

  this.formValid = function(form) {
    if ($(form).valid()) {
      return true;
    } else {
      $(form).valid();
      return false;
    }
  };

  this.validation = function() {
    $.validator.methods.email = function(value, element) {
      return (
        this.optional(element) ||
        /^[^@\s]+@[^@\s]+\.[^@\s]+[^.\s]+?$/.test(value)
      );
    };
    $.validator.addMethod(
      'year',
      function(value, element) {
        return this.optional(element) || /^(19|20)\d{2}$/.test(value);
      },
      'Enter valid year'
    );
    $.validator.addMethod(
      'minmax',
      function(value, element, options) {
        var values = $(options.group);
        var checked = 0;
        var isValid = true;
        for (var i = 0; i < values.length; i++) {
          if (values[i].checked == true) {
            checked++;
          }
        }
        return checked >= options.min && checked <= options.max;
      },
      $.validator.format('Please fill at least {0} of these fields.')
    );

    $(self.forms).each(function() {
      var rules = {
        year: {
          year: true,
        },
        collateral_pdf: {
          accept: 'application/pdf',
        },
        site_photo: {
          accept: 'image/jpeg',
        },
        email_racing_vote: {
          email: true,
        },
      };

      if ($(this).attr('id') == 'contact-form') {
        rules = {
          'issues[]': {
            minmax: {
              min: 1,
              max: 2,
              group: '.issues-category',
            },
            required: true,
          },
          year: {
            year: true,
          },
          phone: {
            require_from_group: [1, '.contact-group'],
          },
          email: {
            require_from_group: [1, '.contact-group'],
          },
        };
      }

      $(this).validate({
        rules: rules,
        errorElement: 'em',
        errorPlacement: function(error, element) {
          if (element.is("[name*='issues']")) {
            $('#category-instructions').append(
              $(error).addClass('form__error-label')
            );
            $('#category-instructions').addClass('form-instruction--error');
          } else if (element.is("[name*='category']")) {
            $('#category-errors')
              .addClass('category__errors--error')
              .append($(error).addClass('form__error-label'));
          } else {
            $(element)
              .closest('.form-field')
              .append($(error).addClass('form__error-label'));
            $(element)
              .closest('.form-field')
              .addClass('form-field--error');
          }
        },
        success: function(label, element) {
          if ($(element).is("[name*='issues']")) {
            $('#category-instructions').removeClass('form-instruction--error');
          } else if ($(element).is("[name*='category']")) {
            $('#category-errors').removeClass('category__errors--error');
          } else {
            $(element)
              .closest('.form-field')
              .removeClass('form-field--error');
          }
        },
        messages: {
          'issues[]': 'Please select one or two issues.',
          collateral_pdf: {
            accept: 'Please select a PDF file only',
          },
          site_photo: {
            accept: 'Please select a jpeg file only',
          },
          phone: {
            require_from_group: 'Please enter email or phone',
          },
          email: {
            require_from_group: 'Please enter email or phone',
          },
          email_racing_vote: {
            email: 'Please enter a valid email.',
          },
        },
      });
    });
  };

  this.submit = function(form, endpoint, data) {
    if (endpoint == '/api/eclub_submit.php') {
      $('.form-field__input--submit').html('Please Wait...');
      $('.form-field__input--submit').attr('disabled', true);
    }

    if (form.attr('id') == 'racing-vote-form') {
      $('.js-submit').attr('disabled', true);
    }
    $.ajax({
      type: 'POST',
      headers: {
        Accept: 'application/json',
      },
      url: endpoint ? endpoint : window.location.href,
      data: data,
      encode: true,
      cache: false,
      contentType: false,
      processData: false,
    }).always(function(data) {
      //Perch Form
      if (typeof data == 'string') {
        var html = $(data);
        if (html.find('.form-success').length) {
          self.success(form);
        }
      }

      //Pardot Form
      if (endpoint && endpoint.indexOf('pardot') >= 0) {
        self.success(form);
      }

      //other Ajax Form. Expects 'message' object in response.
      if (form.attr('id') == 'nscwd-form') {
        if (data.nscwd_franchise != '') {
          document.getElementById('franchise').value = data.nscwd_franchise;
        }
      }

      if (form.attr('id') == 'racing-vote-form') {
        var voted = form.data('voted');
        var container = form.data('container');

        if (data.status === 'success') {
          self.success(form);
        } else if (data.status === 'already_voted') {
          $(container).slideUp();
          $(voted).slideDown();
        } else {
          // handle error
        }
      }

      if (data.message == 'Success') {
        self.success(form);
      }
      if (data.message == 'error') {
        if ($('#madness-form').length) {
          $('#madness-form')
            .find('.button-validation')
            .css('opacity', 1);
        }
      }
    });
  };

  this.success = function(form) {
    var container = form.data('container');

    if ($(container).length) {
      $(container).slideUp();

      $('body, html').animate({
        scrollTop: $(container).offset().top - 100,
      });
    }

    var confirmation = form.data('confirmation');

    if ($(confirmation).length) {
      $(confirmation).slideDown();
    }

    var confirmationHidden = form.data('confirmationhidden');

    if ($(confirmationHidden).length) {
      form.parent().addClass('showConfirmation');
    }

    if ($('#contact-form').length) {
      ga('send', 'pageview', '/contact/thankyou');
    }

    if ($('#eclub-form').length) {
      ga('send', 'pageview', '/eclub/thankyou');
      if (window.location.search.search('racing') >= 0) {
        fbq('trackCustom', 'eClub Racing');
      }
    }

    if ($('#form1_franchise-application').length) {
      ga('send', 'pageview', '/franchising/request-info/thankyou');
    }

    if ($('#form1_site-submittal').length) {
      ga('send', 'pageview', '/franchising/site-submittal/thankyou');
    }

    if ($('#madness-form').length) {
      var step2 = $('.step-response');
      var step3 = $('.step-confirmation');
      var progressBar2 = $('.progress-bar-two');
      var progressBar3 = $('.progress-bar-three');
      var bodyWrapper = $('body');
      var giveawayOptions = $('.mm-giveaway__step-response');

      $('#madness-form')
        .find('.button-validation')
        .css('opacity', 0);

      step2.removeClass('active');
      step3.addClass('active');

      giveawayOptions.hide();
      giveawayOptions.filter('.current-option').show();

      // body class
      bodyWrapper.removeClass('step-two');
      bodyWrapper.addClass('step-three');

      // progress bar
      progressBar2.removeClass('active-step');
      progressBar3.addClass('active-step');

      $('html, body').animate(
        {
          scrollTop: $('#mm-giveaway').offset().top,
        },
        600
      );
    }

    if ($('#nscwd-form').length) {
      if (document.getElementById('franchise').value == '17') {
        $('.nscwd-deal-ayce').show();
        $('.nscwd-deal-eclub').hide();
      } else {
        $('.nscwd-deal-ayce').hide();
        $('.nscwd-deal-eclub').show();
      }

      $('.nscwd-deals-section').show();

      $('html, body').animate(
        { scrollTop: $('#nscwd-deals-section').offset().top },
        600
      );
    }
  };

  this.init();
};
